var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { DolfoChange } from "../../models/DolfoChange";
import { getConfigVar } from "../../utils/Configuration";
import { Tooltip } from "../layout/Tooltip";
var BaseInput = /** @class */ (function (_super) {
    __extends(BaseInput, _super);
    function BaseInput(props, state, value) {
        if (value === void 0) { value = null; }
        var _this = _super.call(this, props) || this;
        _this.getPropertyName = function () { return "value"; };
        _this.getEventType = function () { return "input"; };
        _this.getLabel = function () { return _this.props.label ? React.createElement("label", {
            children: _this.props.required ? [_this.props.label, React.createElement(Tooltip, {
                    children: React.createElement("span", {
                        children: "*",
                        className: "required",
                        key: "required-span"
                    }),
                    label: getConfigVar("REQUIRED"),
                    key: "1"
                })] : _this.props.label,
            className: "dolfo-input-label",
            onClick: _this.labelClick
        }) : React.createElement(React.Fragment); };
        _this.dispatchValue = function (value, input, propertyName, more) {
            var inputToCheck = input || _this.input, property = propertyName || _this.getPropertyName(), ev = DolfoChange.get(_this.getEventType(), true, more), nativeInputValueSetter = Object.getOwnPropertyDescriptor(window[inputToCheck.constructor.name].prototype, property).set;
            nativeInputValueSetter.call(inputToCheck, value);
            inputToCheck.dispatchEvent(ev);
        };
        _this.reset = function (e) {
            e.stopPropagation();
            var disabled = _this.props.disabled;
            if (disabled)
                return;
            _this.dispatchValue(null);
            _this.input.focus();
        };
        _this.setInternalValue = function (internalValue) { return _this.setState({ internalValue: internalValue }); };
        _this.state = __assign(__assign({}, state), { value: value, internalValue: null });
        return _this;
    }
    return BaseInput;
}(React.Component));
export { BaseInput };
